import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

import { ref, toRefs, reactive, onMounted } from "vue";
import dayjs, { Dayjs } from "dayjs";
import type { Rule } from "ant-design-vue/es/form";
import moment from "moment";
import { useRoute } from "vue-router";
import { FormInstance, message } from "ant-design-vue";
import { exportRecordList } from "@/api/pos";
import { getBoughtRecordList } from "@/api/flex";
import { getDownloadUrl } from "@/api/home";
interface DataObject {
  value: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FlexBoughtRecordModal',
  setup(__props, { expose: __expose }) {

const open = ref<boolean>(false);
const activeKey = ref<string>("effective");
const recordData: DataObject = ref(null);
const showModal = (paramater: DataObject) => {
  dataSourceByEffective.value = [];
  dataSourceByInvalid.value = [];
  activeKey.value = "effective";
  open.value = true;
  recordData.value = paramater;
  getTableData("effective");
};

const handleSubmit = (values: any) => {};
const handleFinishFailed = (errors: any) => {};
__expose({
  showModal,
});
const dataSourceByEffective = ref<Array<any>>([]);
const dataSourceByInvalid = ref<Array<any>>([]);

const loading = ref<boolean>(false);
const route = useRoute();
const checkPosDetailInfo = ref(null);
const currentPage = ref(1);
const columnsA = ref<Array<any>>([
  {
    title: "商品名称",
    dataIndex: "skuName",
    key: "skuName",
  },
  {
    title: "总价",
    dataIndex: "totalAmount",
    key: "totalAmount",
  },
  {
    title: "企业支付方式",
    dataIndex: "enterprisePayTypeZh",
    key: "enterprisePayTypeZh",
  },
  {
    title: "企业支付金额",
    dataIndex: "enterprisePayAmount",
    key: "enterprisePayAmount",
  },
  {
    title: "个人支付方式",
    dataIndex: "selfPayTypeZh",
    key: "selfPayTypeZh",
  },
  {
    title: "个人支付金额",
    dataIndex: "selfPayAmount",
    key: "selfPayAmount",
  },
  {
    title: "被保险人姓名",
    dataIndex: "insuredName",
    key: "insuredName",
  },
  {
    title: "被保险人证件号",
    dataIndex: "insuredIdNum",
    key: "insuredIdNum",
  },
  {
    title: "订单时间",
    dataIndex: "orderCreatedAt",
    key: "orderCreatedAt",
  },
]);
const columnsB = ref<Array<any>>([
  {
    title: "商品名称",
    dataIndex: "skuName",
    key: "skuName",
  },
  {
    title: "总价",
    dataIndex: "totalAmount",
    key: "totalAmount",
  },
  {
    title: "企业支付方式",
    dataIndex: "enterprisePayTypeZh",
    key: "enterprisePayTypeZh",
  },
  {
    title: "企业支付金额",
    dataIndex: "enterprisePayAmount",
    key: "enterprisePayAmount",
  },
  {
    title: "个人支付方式",
    dataIndex: "selfPayTypeZh",
    key: "selfPayTypeZh",
  },
  {
    title: "个人支付金额",
    dataIndex: "selfPayAmount",
    key: "selfPayAmount",
  },
  {
    title: "被保险人姓名",
    dataIndex: "insuredName",
    key: "insuredName",
  },
  {
    title: "被保险人证件号",
    dataIndex: "insuredIdNum",
    key: "insuredIdNum",
  },
  {
    title: "订单状态",
    dataIndex: "stateZh",
    key: "stateZh",
  },
  {
    title: "失效时间",
    dataIndex: "orderUpdatedAt",
    key: "orderUpdatedAt",
  },
]);

const getTableData = async (key: "effective") => {
  loading.value = true;
  let params = {
    accountCenterId: recordData.value.accountCenterId,
    employeeId: recordData.value.employeeId,
    orderDetailStateSet: [] as string[], // 明确指定 orderDetailStateSet 是一个字符串数组
  };
  if (key == "effective") {
    params.orderDetailStateSet.push("PAID");
  } else {
    params.orderDetailStateSet.push("UNPAID");
    params.orderDetailStateSet.push("REFUNDING");
    params.orderDetailStateSet.push("INVALID");
    params.orderDetailStateSet.push("REFUNDED");
  }
  let res: any = await getBoughtRecordList(params);
  if (res.code == 200) {
    loading.value = false;
    key == "effective"
      ? (dataSourceByEffective.value = res.data)
      : (dataSourceByInvalid.value = res.data);
  } else {
    message.error(res.msg);
  }
};

const onchangeTabs = (activeKey: any) => {
  getTableData(activeKey);
};

const handleDownload = async (record: any) => {
  let params = {
    id: record.attachmentId,
    duration: 60 * 10,
  };
  let res = await getDownloadUrl(params);
  let a = document.createElement("a");
  a.href = res.data;
  a.click();
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((open).value = $event)),
      width: "1200px",
      okText: "确定",
      cancelText: "取消",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: activeKey.value,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
          onChange: onchangeTabs
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "effective",
              tab: "有效购买记录"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: dataSourceByEffective.value,
                  style: {"margin-top":"4px"},
                  columns: columnsA.value,
                  loading: loading.value
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'fileName' && record.state == 'SUCCESS')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          style: {"color":"#42b983"},
                          onClick: ($event: any) => (handleDownload(record))
                        }, _toDisplayString(record.fileName), 9, _hoisted_1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "invalid",
              tab: "失效购买记录"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: dataSourceByInvalid.value,
                  style: {"margin-top":"4px"},
                  columns: columnsB.value,
                  loading: loading.value
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'fileName' && record.state == 'SUCCESS')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          style: {"color":"#42b983"},
                          onClick: ($event: any) => (handleDownload(record))
                        }, _toDisplayString(record.fileName), 9, _hoisted_2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})